import React from "react";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="para-body-s-regular color-text-body-primary">© Copyright 2020 - {currentYear} Edge LLC </div>
      <div className="para-body-s-regular color-text-body-primary">
        {process.env.REACT_APP_NAME}
        {` ${process.env.REACT_APP_VERSION}`}
      </div>
    </footer>
  );
}

export default Footer;
